import React from 'react';
import { IconDoc } from '../icons';

/**
 * OriginalStateItem - The "Session Start" item at the top of the history
 */
const OriginalStateItem = ({ undoStackLength, redoStackLength, onClick }) => {
  const isCurrent = undoStackLength === 0;
  
  const itemClass = [
    'history-panel__item',
    'history-panel__item--original',
    isCurrent && 'history-panel__item--current',
    !isCurrent && 'history-panel__item--past',
  ].filter(Boolean).join(' ');

  return (
    <div 
      className={itemClass}
      onClick={onClick}
      title={isCurrent ? 'Current state (original)' : 'Click to revert to original state'}
    >
      <span className="history-panel__item-number">○</span>
      <span className="history-panel__item-icon"><IconDoc /></span>
      <div className="history-panel__item-content">
        <span className="history-panel__item-title">Session Start</span>
      </div>
      <span className="history-panel__item-time"></span>
    </div>
  );
};

export default OriginalStateItem;
